export default __webpack_public_path__ + "static/media/login-illustration.c966f7c0.svg";